import { Injectable } from '@angular/core';
import { GgProductBundlesAdapter } from './gg-product-bundles.adapter';
import { BundleGroupWsDTO } from '../../model/bundles.model';
import { Observable } from 'rxjs';
import { Occ } from '@spartacus/core';
import CartModification = Occ.CartModification;

@Injectable()
export class GgProductBundlesConnector {
  constructor(private productBundlesAdapter: GgProductBundlesAdapter) {}

  addBundleToCart(cartId: string, userId: string, bundleGroup: BundleGroupWsDTO): Observable<CartModification> {
    return this.productBundlesAdapter.addBundleToCart(cartId, userId, bundleGroup);
  }

  removeBundleFromCart(userId: string, cartId: string, entryNumbers: number[]): Observable<any> {
    return this.productBundlesAdapter.removeBundleFromCart(userId, cartId, entryNumbers);
  }
}
